export const unsetAuthTokens = (): void => {
	localStorage.removeItem( "token" )
}